import React, {Component} from 'react'
import "amazon-connect-streams"
import "amazon-connect-chatjs"
import Cookies from 'universal-cookie';
import Template, {
    CONTENT_TYPE_CHAT_ENDED,
    CONTENT_TYPE_EVENT,
    CONTENT_TYPE_FEEDBACK,
    CONTENT_TYPE_JOINED,
    CONTENT_TYPE_LEFT,
    CONTENT_TYPE_TRANSFER,
    CONTENT_TYPE_TRANSFER_FAILED,
    CONTENT_TYPE_TRANSFER_SUCCEEDED,
    CONTENT_TYPE_TYPING,
    ROLE_AGENT,
    ROLE_CUSTOMER,
    ROLE_SYSTEM
} from '../Components/Templates'
import {Container, Row} from "react-bootstrap"
import axios from "axios"
import HEADER_SVG from "../images/u14.png"
import {datadogLogs} from '@datadog/browser-logs'
import {checkEmptyInputText, getTimeAMPMFormat, hashCode, openUrl} from '../utils/commonHelper'
import {
    LOCAL_STORAGE_KEY_AGENT_DATA,
    LOCAL_STORAGE_KEY_FEEDBACK_DATA,
    MESSAGE_BILLING_INFO, MESSAGE_ESTIMATES_INFO,
    MESSAGE_HELP_INFO,
    MESSAGE_HI_IAM_HOPE,
    MESSAGE_QUEUE_RN_INFO, MESSAGE_REFERRAL_WMNS_GEN,
    MESSAGE_STANDARD_INFO,
    QUEUE_NAME_BILLING, QUEUE_NAME_BILLING_ES, QUEUE_NAME_ESTIMATES, QUEUE_NAME_GLP,
    QUEUE_NAME_MAIN, QUEUE_NAME_NEUROLOGY, QUEUE_NAME_REFERRAL_WMNS_GEN, QUEUE_NAME_REFERRAL_WMNS_GEN_2,
    QUEUE_NAME_RN
} from '../utils/constant'
import {ChatSound} from "./Sound";
import {
    keydownHandler,
    i18n,
    removeLocalStorageData,
    setLocalStorageData,
    jsonParse,
    getLocalStorageData
} from '../utils/commonHelper'
import {getRealQueueName} from "../utils/queueHelper";

const cookies = new Cookies();

const QUEUE_TYPE_DEFAULT = 0;
const QUEUE_TYPE_PRESCRIPTION_REFILL_REQUEST = 1;
const QUEUE_TYPE_STANDALONE_CHAT = 2;
const QUEUE_TYPE_RN = 5; // Nurse Advice
const QUEUE_TYPE_BILLING = 6;

// Timeouts in ms
export const TIMEOUT_CUSTOMER_MESSAGE = 120000;
export const TIMEOUT_WAITING_AGENT = 300000;
export const TIMEOUT_WAITING_QUEUE_INFO = 60000;
export const TIMEOUT_END_LIVE_CHAT = 1800000; // 30 min
const TIMEOUT_CLEAR_CHAT = 600000;
const TIMEOUT_TYPING_EVENT = 30000;
const TIMEOUT_SHOW_CHATBOT_MESSAGE = 500;

const MSG_GET_INTENT_DESCRIPTION = 'GET_INTENT_DESCRIPTION';
const MSG_START_CHAT = 'START_CHAT';
const MSG_WAITING_AGENT = 'WAITING_AGENT';
const MSG_LEX_BOT_ENTER_CHAT = 'LEX_BOT_ENTER_CHAT';

const Timers = {
    waitingAgent: null,
    waitingQueueInfo: null,
    endLiveChat: null,
    clearChat: null,
    typingEvent: null,
    showChatbotMessage: null,
};

export default class Main extends Component {
    constructor(props) {
        super(props)

        const chatOpts = props.data ? jsonParse(atob(props.data)) : {};
        if (!chatOpts.username) {
            chatOpts.username = "Customer_" + this.makeId()
        }
        if (!chatOpts.customerName) {
            chatOpts.customerName = "Customer #" + this.makeId(4, '0123456789')
        }
        if (!chatOpts.fontName) {
            chatOpts.fontName = "Roboto"
        }
        const userParams = props.userParams ? props.userParams : {};
        if (userParams.username) {
            chatOpts.customerName = userParams.username;
        }

        this.cookiePrefix = 'odeza_stn_chat_' + hashCode((props.startQueueName) ?
            props.startQueueName
            :
            (userParams.mrn + userParams.department + userParams.ref).toString()
        ).toString(16) + '_';

        const savedConnectKeys = cookies.get(this.cookiePrefix + 'connectKeys');
        if (savedConnectKeys) {
            chatOpts.connectKeys = savedConnectKeys;
        }

        const chatBotName = chatOpts.chatBotName ? chatOpts.chatBotName : 'Atrium Virtual Assistant'
        this.state = {
            chatInitiated: false,
            chatEnded: false,
            chatEndedByCustomer: false,
            chatCanceled: false,
            doEndChat: false,
            showEndChat: false,
            showEndLiveChat: false,
            // acceptedAgreement: chatOpts.agreement,
            message: "",
            messages: [],
            incomingChatbotMessages: [],
            localMessages: [],
            showLocalMessages: false,
            systemParticipantId: null,
            connectSuccess: false,
            lastTimeMessageSend: null,
            lastTimeTyping: null,
            isTyping: true,
            attempts: 0,
            lexEnter: false,
            showCancelButton: false,
            cancelButtonTitle: null,
            showRestartChat: false,
            needShowRestartChat: true,
            chatSession: null,
            feedbackValue: {},
            showFeedback: false,
            prescription: null,
            agentConnected: false,
            askName: false,
            askDOB: false,
            askDOBTitle: null,
            askPhone: false,
            feedbackLoaderStatus: null,
            windowFocused: true,
            showTimeoutMessage: false,
            showCleanedChatMessage: false,
            showCancelFeedback: false,
            agents: {},
            restartAfterFeedback: false,
            showInputError: false,
            queueMessages: {},
            queueMessagesLoading: false,
            ...userParams,
            ...chatOpts
        }

        this.messageSound = new ChatSound(chatOpts.incomingMessageSoundUrl ?
            chatOpts.incomingMessageSoundUrl
            :
            'https://static.odeza.com/assets/media/chatbot-incoming-message.mp3'
        );
    }

    onUpdateFeedback = (feedbackValue) => {
        this.setState({feedbackValue: feedbackValue})
    }

    getCurrentContactId = () => {
        const {contactId} = (this.state.contactId) ? this.state : (this.state.chatSession?this.state.chatSession.controller:{});
        return contactId;
    }

    waitingAgentTimer = () => {
        if (Timers.waitingAgent !== null) {
            clearTimeout(Timers.waitingAgent);
            Timers.waitingAgent = null;
        }
        return setTimeout(() => {
            if (this.state.session) {
                this.state.session.sendMessage({
                    contentType: 'text/plain',
                    message: MSG_WAITING_AGENT
                });
            }
        }, TIMEOUT_WAITING_AGENT);
    };
    getQueueInfo = (instanceId,queueId,contactId) =>{
        const url = process.env.REACT_APP_AMAZON_API_URL + `/queue/waitinginfo?instance_id=${instanceId}&queue_id=${queueId}&contact_id=${contactId()}`;
        axios.get(url, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        })
            .then((response) => {
                let _messages = this.state.messages;
                for (let i = _messages.length - 1; i >= 0; i--) {
                    if (_messages[i] && _messages[i].chatbotIsWaitingInfo) {
                        _messages[i].Content = (response.data.message) ? response.data.message : _messages[i].Content;
                        this.setState({
                            messages: _messages,
                            showCancelButton: true,
                            showWaitingAgentCancel:true
                        });
                        break;
                    }
                }
            })
            .finally(() => {
                Timers.waitingQueueInfo = this.waitingQueueInfoTimer(instanceId, queueId, () => this.getCurrentContactId());
            });
    }
    waitingQueueInfoTimer = (instanceId, queueId, contactId) => setTimeout(() => {
        if (this.state.agentConnected
            || this.state.chatCanceled
            || this.state.chatEnded
        ) {
            Timers.waitingQueueInfo = null;
            return;
        }
        this.getQueueInfo(instanceId, queueId, contactId)
    }, TIMEOUT_WAITING_QUEUE_INFO);

    getQueueMessages = (queueId) => {
        let queueList = [];
        if (Array.isArray(queueId)) {
            queueList.concat(queueId);
        } else {
            queueList.push(queueId);
        }
        const isValidState = this.state?.queueMessages && typeof this.state.queueMessages === 'object';
        if (isValidState) {
            const keys = Object.keys(this.state.queueMessages);
            queueList = queueList.filter(item => !keys.includes(item));
        }
        if (!queueList.length) {
            return;
        }
        this.setState({queueMessagesLoading: true});
        const url = process.env.REACT_APP_AMAZON_API_URL + '/queue/messages';
        return axios.post(url, JSON.stringify({
            "practice_id": process.env.REACT_APP_PRACTICE_ID,
            "queue_id": queueList // can be a single ID or a list of IDs
        }), {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        })
            .then((response) => {
                if (isValidState) {
                    this.setState(prevState => {
                        return {queueMessages: {...prevState.queueMessages, ...response.data}};
                    });
                } else {
                    this.setState({
                        queueMessages: response.data
                    });
                }
            })
            .finally(() => {
                this.setState({queueMessagesLoading: false});
            });
    }

    endLiveChatTimer = () => setTimeout(() => {
        Timers.endLiveChat = null;
        this.setState({
            doEndChat: true
        });
        this.setState({
            showTimeoutMessage:true,
        });
    }, TIMEOUT_END_LIVE_CHAT);

    clearChatTimer = (timeout) => setTimeout(() => {
        Timers.clearChat = null;
        if (!this.userSentAnyMessage) {
            return;
        }
        this.setState({
            messages: [],
            showTimeoutMessage: false,
            showCleanedChatMessage: true
        });
    }, timeout);

    updateLastMessageDate = async () => {
        let needUpdate = false;
        let curDate = new Date();
        if (!this.state.lastTimeMessageSend) {
            this.state.lastTimeMessageSend = new Date();
            needUpdate = true;
        } else {
            needUpdate = (curDate.getTime() - this.state.lastTimeMessageSend.getTime() >= TIMEOUT_CUSTOMER_MESSAGE);
        }
        if (needUpdate) {
            try {
                const {contactId} = this.state.session.controller;
                axios.patch(process.env.REACT_APP_AMAZON_API_URL + '/contacts?contactId=' + contactId,
                    'contactId=' + contactId, {
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                        }
                    });
            } catch (e) {
                console.log(e);
            }
            this.state.lastTimeMessageSend = curDate;
        }
    }

    updateCustomerName = async (name) => {
        try {
            let queueType = QUEUE_TYPE_STANDALONE_CHAT;
            switch (this.props.startQueueName) {
                case QUEUE_NAME_MAIN:
                    queueType = QUEUE_TYPE_DEFAULT;
                    break;
                case QUEUE_NAME_RN:
                    queueType = QUEUE_TYPE_RN;
                    break;
                case QUEUE_NAME_BILLING:
                    queueType = QUEUE_TYPE_BILLING;
                    break;
            }
            const {contactId} = this.state.session.controller;
            let _name = name.replace(/[?%$&/\\`'"~:;_=<>\[\]{}+]/g, ''); // encode URI not work with Agent chat
            let urlData = encodeURI('contactId=' + contactId + '&name=' + _name + '&queueType=' + queueType);
            await axios.patch(process.env.REACT_APP_AMAZON_API_URL + '/contacts/attributes?' + urlData, urlData, {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    }
                });
        } catch (e) {
            console.log(e);
        }
    }

    fetchCssFromUrl = (src, externals = []) => {
        new Promise((resolve, reject) => {
            const style = document.createElement('link')
            style.setAttribute('href', src)
            style.setAttribute('rel', "stylesheet")
            style.setAttribute('type', "text/css")
            style.addEventListener('load', () => {
                resolve(externals.map(key => {
                    const ext = window[key]
                    typeof ext === 'undefined' && console.warn(`No external named '${key}' in window`)
                    return ext
                }))
            })
            // style.addEventListener('error', reject)
            document.getElementsByTagName('head')[0].appendChild(style)
        })
    }

    getKeys = async (username, customerName,  newKeys = false) => {
        let self = this;
        if (self.state.connectKeys && !newKeys) {
            try {
                if (typeof self.state.connectKeys !== 'object') {
                    return jsonParse(self.state.connectKeys)
                }
                return self.state.connectKeys;
            } catch (e) {}
        }
        let additionalData={};
        if (self.state.token !== undefined && self.state.token){
            additionalData = {
                token:self.state.token,
                queue:self.state.queueName
            }
        } else {
            additionalData = {
                mrn: self.state.mrn,
                department: self.state.department,
                ref: self.state.ref
            }
        }

        return axios.post(process.env.REACT_APP_AMAZON_API_URL, JSON.stringify({
            "apiKey": "standalone",
            "ParticipantDetails": {
                "DisplayName": customerName
            },
            "Username": username,
            "Attributes": {
                "customerName": customerName,
                "queueType": (self.props.startQueueName === QUEUE_NAME_MAIN) ? QUEUE_TYPE_DEFAULT : QUEUE_TYPE_STANDALONE_CHAT,
                "additionalData": JSON.stringify(additionalData),
                "startQueueName": self.props.startQueueName ? self.props.startQueueName : '',
            }
        }), {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        })
            .then((response) => {
                const keys = response?.data?.data;
                self.setState({connectKeys: keys})
                if (response?.data?.messages) {
                    self.setState({predefinedMessages: response.data.messages})
                }
                const s_keys = JSON.stringify(keys);
                window.parent.postMessage({'name': 'connectKeys', value: s_keys}, '*')
                // For standalone chat only
                self.saveConnectKeysToCookies(s_keys);
                return keys;
            })
            .catch(function (error) {
                self.setState({connectKeys: false})
            });
    };

    deleteCookies = () => {
        cookies.remove(this.cookiePrefix + 'username');
        cookies.remove(this.cookiePrefix + 'customer');
        cookies.remove(this.cookiePrefix + 'agreement');
        cookies.remove(this.cookiePrefix + 'connectKeys');
    };

    saveConnectKeysToCookies = (keys) => {
        cookies.set(this.cookiePrefix + 'connectKeys', keys, {path: '/', sameSite: 'strict', maxAge: 86400});
    };

    saveUserNameToCookies = (name) => {
        cookies.set(this.cookiePrefix + 'username', name, {path: '/', sameSite: 'strict', maxAge: 86400});
    }

    getFirstStartMessage = () => {
        /*!!! Only for Main queue !!!*/
        if (this.props.startQueueName !== QUEUE_NAME_MAIN
            || this.state.predefinedMessages?.welcomeMessage
        ) {
            return;
        }
        const messageContent = {
            type: "interactive",
            intent: "StartChatbot",
            title: (this.props.startQueueName === QUEUE_NAME_MAIN) ? MESSAGE_STANDARD_INFO : MESSAGE_HI_IAM_HOPE
        };
        return {
            "Content": JSON.stringify(messageContent),
            "ContentType": "text/plain",
            "Type": "MESSAGE",
            "DisplayName": "BOT",
            "ParticipantRole": "SYSTEM",
            "startMessage": true
        };
    }

    getSecondStartMessage = () => {
        let content;
        if (this.state.predefinedMessages?.welcomeMessage) {
            content = this.state.predefinedMessages.welcomeMessage;
        } else {
            switch (getRealQueueName(this.props.startQueueName)) {
                case QUEUE_NAME_MAIN:
                    content = MESSAGE_HELP_INFO;
                    break;
                case QUEUE_NAME_RN:
                    content = MESSAGE_QUEUE_RN_INFO;
                    break;
                case QUEUE_NAME_BILLING:
                case QUEUE_NAME_BILLING_ES:

                    content = MESSAGE_BILLING_INFO;
                    break;
                case QUEUE_NAME_NEUROLOGY:
                case QUEUE_NAME_ESTIMATES:
                    content = MESSAGE_ESTIMATES_INFO;
                    break;
                case QUEUE_NAME_REFERRAL_WMNS_GEN:
                    content = MESSAGE_REFERRAL_WMNS_GEN;
                    break;
                default:
                    content = MESSAGE_STANDARD_INFO;
                    break;
            }
        }
        if (Array.isArray(content)) {
            return content.map(msg => {
                return {
                    "Content": msg,
                    "ContentType": "text/plain",
                    "Type": "MESSAGE",
                    "DisplayName": "BOT",
                    "ParticipantRole": "SYSTEM"
                };
            });
        } else {
            return {
                "Content": content,
                "ContentType": "text/plain",
                "Type": "MESSAGE",
                "DisplayName": "BOT",
                "ParticipantRole": "SYSTEM"
            };
        }
    }

    createSession = async (data) => {
        if (data) {
            try {
                const {ContactId, ParticipantId, ParticipantToken} = data.startChatResult;
                const firstStartMessage = this.getFirstStartMessage();
                this.setState({
                    messages: (firstStartMessage ? [firstStartMessage] : [])
                });
                const session = await window.connect.ChatSession.create({
                    chatDetails: { // REQUIRED
                        contactId: ContactId, // REQUIRED
                        participantId: ParticipantId, // REQUIRED
                        participantToken: ParticipantToken, // REQUIRED
                    },
                    options: { // optional
                        region: 'us-east-1', // optional, defaults to `region` set in `connect.ChatSession.setGlobalConfig()`
                    },
                    type: window.connect.ChatSession.SessionTypes.CUSTOMER, // REQUIRED
                });
                const {connectSuccess} = await session.connect();
                if (!this.state.newSession) {
                    this.setState({
                        isTyping: false,
                        lexEnter: true,
                    })
                }
                const secondStartMessage = this.getSecondStartMessage();
                if (secondStartMessage && this.props.startQueueName !== QUEUE_NAME_GLP) {
                    if (Array.isArray(secondStartMessage)) {
                        this.setState({
                            messages: [...this.state.messages, ...secondStartMessage]
                        });
                    } else {
                        this.setState({
                            messages: [...this.state.messages, secondStartMessage]
                        });
                    }
                }
                this.setState({
                    connectSuccess: connectSuccess,
                    chatSession: session,
                });
                window.addEventListener("message", (e) => {
                    switch (e.data.name) {
                        case 'disconnect':
                            this.endChat();
                            break;
                    }
                });

                session.onMessage(event => {
                    this.onMessage(event);
                });

                session.onEnded(event => {
                    this.onChatEnded(event);
                });

                session.onConnectionBroken(event => {
                    this.onChatEnded(event);
                });

                session.onConnectionEstablished(this.onConnectionEstablished);

                session.onTyping(event => {
                    const {data} = event
                    if (data.ParticipantRole === "AGENT") {
                        this.updateTypingEventTimer(true);
                    }
                });

                let messages = []
                if (!this.state.newSession) {
                    messages = await this.loadTranscript(session);
                }
                this.setState({
                    session: session,
                    messages: [...this.state.messages, ...messages]
                })
                return connectSuccess;
            } catch (e) {
                const {connectSuccess} = e
                this.setState({
                    connectSuccess: connectSuccess
                })
                return connectSuccess
            }
        } else {
            return false
        }
    }

    setStates = (states) => {
        const statesNames = Object.keys(states);
        if (statesNames.length) {
            this.setState(prevState => {
                statesNames.map(name => {
                    prevState[name] = states[name]
                });
                return prevState;
            });
        }
    }

    onConnectionEstablished = (event) => {
        /* This method called 2 times when connection established.
           Last have event.data object.
         */
        if (event.data) {
            if (!this.state.chatInitiated) {
                this.setState({
                    chatInitiated: true,
                });
            } else {
                this.loadTranscript(this.state.session)
                    .then(messages => {
                        const firstStartMessage = this.getFirstStartMessage();
                        const secondStartMessage = this.getSecondStartMessage();
                        let startMessages = [];
                        if (firstStartMessage) {
                            startMessages.push(firstStartMessage);
                        }
                        if (secondStartMessage) {
                            if (Array.isArray(secondStartMessage)) {
                                secondStartMessage.forEach(msg => {
                                    startMessages.push(msg);
                                });
                            } else {
                                startMessages.push(secondStartMessage);
                            }
                        }
                        this.setState({
                            messages: [
                                ...startMessages,
                                ...messages
                            ]
                        });
                        // this.scrollToBottom();
                    });
            }
        }
    }

    loadTranscript = async (session) => {
        let result = [];
        const awsSdkResponse = await session.getTranscript({
            maxResults: 100,
            sortOrder: "ASCENDING"
        });
        const {Transcript} = awsSdkResponse.data;
        let states = Object.assign(this.state, {});
        const messages = Transcript.filter(message => message.Content !== MSG_LEX_BOT_ENTER_CHAT);
        const agentData = await getLocalStorageData(LOCAL_STORAGE_KEY_AGENT_DATA)
        const feedbackData = await getLocalStorageData(LOCAL_STORAGE_KEY_FEEDBACK_DATA)

        try {
            const prepareFeedbackData = Object.entries(feedbackData).reduce((acc, [key, value]) => {
                acc.feedbackValue[value?.ContactId] = {feedbackResult: value?.feedbackResult}
                return acc
            }, {feedbackValue: {}})

            const prepareAgentsData = Object.entries(agentData).reduce((acc, [key, value]) => {
                acc.agents[value?.ContactId] = {agentName: value?.agentName}
                return acc
            }, {agents: {}})

            Object.assign(states, prepareFeedbackData, prepareAgentsData)
        } catch (e) {
            console.warn(e)
        }

        let queueMessagesNeeded = [];

        messages.map((data, key, arr) => {
            if (Object.keys(feedbackData).includes(data.Id)) {
                data.ContactId = feedbackData[data.Id]?.ContactId;
            }
            if (Object.keys(agentData).includes(data.Id)) {
                data.ContactId = agentData[data.Id]?.ContactId;
            }
            // restore intents history
            let processedChatbotMsg = {};
            if (data.ParticipantRole === ROLE_SYSTEM && data.Type === 'MESSAGE') {
                processedChatbotMsg = this.processIncomingChatbotMessage(data, states, true);
                if (Object.keys(processedChatbotMsg.newStates || {}).length) {
                    states = Object.assign(states, processedChatbotMsg.newStates);
                }
                // replace waiting information & mark message
                if (processedChatbotMsg.jsonData && processedChatbotMsg.jsonData.waitingMsg) {
                    data.chatbotIsWaitingInfo = true;
                    data.Content = JSON.stringify(processedChatbotMsg.jsonData.waitingMsg);
                }
                if (processedChatbotMsg.jsonData && processedChatbotMsg.jsonData.queueName) {
                    data.queueName = processedChatbotMsg.jsonData.queueName;
                    data.queueId = processedChatbotMsg.jsonData.queueId;
                    if (data.queueId) {
                        queueMessagesNeeded.push(data.queueId);
                    }
                }
                // restore history
                let customerData = null;
                for (let i = key + 1; i < arr.length; i++) {
                    if (arr[i].ParticipantRole === 'CUSTOMER'
                        && arr[i].Type === 'MESSAGE'
                        && data.Content.indexOf(MSG_GET_INTENT_DESCRIPTION) === -1
                    ) {
                        customerData = {
                            inputText: arr[i].Content
                        };
                        break;
                    }
                }
            }
            // add to result array
            result.push(data);
            if (processedChatbotMsg.newMessages) {
                result.push(...processedChatbotMsg.newMessages);
            }
            // update states & get additional messages
            const processedResult = this.processMessage(data, states, true);
            if (Object.keys(processedResult.newStates || {}).length) {
                states = Object.assign(states, processedResult.newStates);
            }
            if (processedResult.newMessages) {
                result.push(...processedResult.newMessages);
            }
        });

        if (queueMessagesNeeded.length) {
            await this.getQueueMessages(queueMessagesNeeded);
        }

        this.setStates(states);
        return result;
    }

    componentDidMount =  () => {
        const appHeight = () => {
            const el = document.getElementById('chat__wrap');
            if (el && el.style) {
                el.style.setProperty('height', `${window.innerHeight}px`);
            }
        }
        window.addEventListener('resize', appHeight);
        appHeight();

        datadogLogs.init({
            clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN,
            site: 'datadoghq.com',
            forwardErrorsToLogs: true,
            sampleRate: 100,
            service: 'customer-chat-app',
            env: process.env.REACT_APP_ENV
        });

        this.initiateChat();
        this.initiateChatScrolling();
    };

    componentWillUnmount = () => {
        clearTimeout(Timers.waitingAgent);
        clearTimeout(Timers.waitingQueueInfo);
        clearTimeout(Timers.endLiveChat);
        clearTimeout(Timers.typingEvent);
        clearInterval(Timers.showChatbotMessage);
    };

    initiateChatScrolling = () => {
        /* Futures from common chat not included for Standalone */

        window.addEventListener("focus", () => {
            if (this.state.isMobile) {
                setTimeout(() => this.scrollToBottom(), 700);
            }
        });

        document.addEventListener("visibilitychange", () => {
            if(!document.hidden) {
                setTimeout(() => this.scrollToBottom(), 700);
            }
        }, false);
    };

    initiateChat = async () => {
        const self = this;

        // For standalone chat only
        let isMobile = window.matchMedia("only screen and (max-width: 460px)").matches;
        this.setState({isMobile: isMobile});

        window.addEventListener("message", (e) => {
            switch (e.data.name) {
                case 'isMobile':
                    const isMobile = e.data.value;
                    self.setState({isMobile: isMobile})
                    if (!isMobile && self.textarea) {
                        self.textarea.focus();
                    }
                    break;
            }
        });
        window.addEventListener("focus", () => self.setState({windowFocused: true}));
        window.addEventListener("blur", () => self.setState({windowFocused: false}));
        window.addEventListener('visibilitychange', () => {
            if (!document.hidden) {
                const dateNow = Date.now();
                if (self.chatEndTime && ((dateNow - self.chatEndTime) > TIMEOUT_CLEAR_CHAT)) {
                    Timers.clearChat = self.clearChatTimer(0);
                }
            }
        });

        if (this.state.cssUrl) {
            this.fetchCssFromUrl(this.state.cssUrl, ['eruda'])
        }

        this.setState({
            chatInitiated: false,
            // chatEnded: false,
            chatEndedByCustomer: false,
            isTyping: true,
            needShowRestartChat: true,
            agents: {},
        });

        if (Timers.showChatbotMessage) {
            clearInterval(Timers.showChatbotMessage);
        }
        Timers.showChatbotMessage = this.initShowIncomingChatbotMessages();

        if (Timers.waitingAgent) {
            clearTimeout(Timers.waitingAgent);
            Timers.waitingAgent = null;
        }
        if (Timers.waitingQueueInfo) {
            clearTimeout(Timers.waitingQueueInfo);
            Timers.waitingQueueInfo = null;
        }
        if (Timers.endLiveChat) {
            clearTimeout(Timers.endLiveChat);
            Timers.endLiveChat = null;
        }
        this.chatEndTime = null;
        this.userSentAnyMessage = false;
        if (Timers.clearChat) {
            clearTimeout(Timers.clearChat);
            Timers.clearChat = null;
        }
        let {attempts, username, customerName} = this.state;
        let connectSuccess = false
        while (!connectSuccess && attempts < 3) {
            if (attempts && this.state.isDebug === undefined) {
                username = "Customer_" + this.makeId();
                if (!customerName) {
                    customerName = "Customer #" + this.makeId(4, '0123456789');
                }
                this.setState({
                    username: username,
                    customerName: customerName
                });
                window.parent.postMessage({'name': 'newUsername', value: username}, '*');
                // For standalone chat only
                this.saveUserNameToCookies(username);
            }
            const keys = await this.getKeys(username, customerName, attempts ? true : false);
            connectSuccess = await this.createSession(keys)
            attempts++;
            this.setState({
                attempts: attempts
            })
        }

        if (!isMobile && this.textarea) {
            this.textarea.focus();
        }

        //this.scrollToBottom();
    }

    processMessage = (data, states, isRestored = false) => {
        let newStates = {};
        let newMessages = [];

        const contactId = data?.ContactId || states?.contactId || this.getCurrentContactId()

        if (data?.ContactId && contactId !== states?.contactId) {
            if (!isRestored && data?.DisplayName) {
                setLocalStorageData(LOCAL_STORAGE_KEY_AGENT_DATA, {
                    [data.Id]: {
                        ContactId: data.ContactId, ...states.agents[data.ContactId],
                        agentName: data?.DisplayName || 'agent'
                    }
                })
            }

            newStates = Object.assign(newStates, {
                contactId: contactId,
            });
        }

        if (!isRestored) {
            if (Timers.endLiveChat !== null) {
                clearTimeout(Timers.endLiveChat);
            }
            Timers.endLiveChat = this.endLiveChatTimer();

            if (data.ParticipantRole === ROLE_CUSTOMER) {
                this.updateLastMessageDate();
            }
        }

        if (!states.agentConnected
            && states.chatEnded
            && data.ContentType === CONTENT_TYPE_CHAT_ENDED
        ) {
            newStates = Object.assign(newStates, {
                showTimeoutMessage: true
            });
        }

        if (data.ParticipantRole === ROLE_CUSTOMER
            && data.Type === 'MESSAGE'
        ) {
            // History back
            if ((data.Content && data.Content.indexOf("sys_back:") === 0)
                || (isRestored && states.askDOB)
            ) {
                newStates = Object.assign(newStates, {
                    askName: false,
                    askDOB: false,
                });
            }
            // Agent auto message
            if (this.nextAgentAutoMessageShow) {
                newMessages.push(this.nextAgentAutoMessageShow);
                this.nextAgentAutoMessageShow = null;
            }
        }

        if (data.Type === CONTENT_TYPE_EVENT) {
            if([CONTENT_TYPE_JOINED, CONTENT_TYPE_TRANSFER_FAILED].indexOf(data.ContentType) !== -1) {
                newStates = Object.assign(newStates, {
                    isTransferring: false
                });
            }

            if (data.ContentType === CONTENT_TYPE_JOINED) {
                if (data.ParticipantRole === ROLE_AGENT) {
                    // Agent connected
                    newStates = Object.assign(newStates, {
                        contactId: data.ContactId,  // don't use contactId constant!
                        agentName: data.DisplayName,
                        isTransferred: !!states.isTransferring,
                        showEndLiveChat: true,
                        showCancelButton: false,
                        showFeedback: true,
                        agentConnected: true,
                        askName: false,
                        askDOB: false,
                        askPhone: false,
                        agents: {
                            ...(states?.agents || {}),
                            [contactId]: {...states.agents[contactId], agentName: data.DisplayName}
                        },
                    });

                    if (data?.ContactId) {
                        setLocalStorageData(LOCAL_STORAGE_KEY_AGENT_DATA, {
                            [data.Id]: {
                                ContactId: data.ContactId, ...states.agents[data.ContactId],
                                agentName: data.DisplayName
                            }
                        })
                    }
                    // add Ask DOB message
                    if (states.currentQueueName === 'Billing' || states.currentQueueName === 'Spanish Billing') {
                        const askDOBMsg = this.getAskDobMessage();
                        newMessages.push(askDOBMsg);
                        this.nextAgentAutoMessageShow = this.getDobThanksMessage();
                        const jsonData = jsonParse(askDOBMsg.Content);
                        newStates = Object.assign(newStates, {
                            askName: true,
                            askDOB: true,
                            askDOBTitle: (jsonData || {}).askDOBTitle
                        });
                    }
                    // Clear timers
                    if (Timers.waitingAgent !== null) {
                        clearTimeout(Timers.waitingAgent);
                        Timers.waitingAgent = null;
                    }
                    if (Timers.waitingQueueInfo !== null) {
                        clearTimeout(Timers.waitingQueueInfo);
                        Timers.waitingQueueInfo = null;
                    }
                    try {
                        if (!this.state.windowFocused) {
                            this.messageSound.play(false, true);
                        }
                    } catch (e) {}
                } else if (data.ParticipantRole === ROLE_CUSTOMER) {
                    // Customer connected
                    if (Timers.endLiveChat !== null) {
                        clearTimeout(Timers.endLiveChat);
                        Timers.endLiveChat = null;
                    }
                }
            }

            if (data.ContentType === CONTENT_TYPE_LEFT) {
                if (data.ParticipantRole === ROLE_AGENT) {
                    newStates = Object.assign(newStates, {
                        agentConnected: false
                    });
                }

                if (!states.chatEnded && !states.isTransferring && !states.chatCanceled) {
                    const needShowFeedback = Object.keys(states.agents).length > 0 || isRestored;
                    newStates = Object.assign(newStates, {
                        chatEnded: true,
                        showFeedback: needShowFeedback,
                    });
                    newMessages.push({
                        ContentType: CONTENT_TYPE_CHAT_ENDED,
                        Content: 'Ended by '+ (states.chatEndedByCustomer ? 'Customer' : 'Agent')+' ' + getTimeAMPMFormat(new Date()),
                        ContactId: contactId,
                        Type: CONTENT_TYPE_EVENT,
                    });
                    if (needShowFeedback) {
                        newStates = Object.assign(newStates, {
                            agents: {
                                ...states.agents,
                                [contactId]: {...states.agents[contactId], chatEnded: true}
                            },
                        });
                        newMessages.push({
                            ContentType: CONTENT_TYPE_FEEDBACK,
                            ContactId: contactId,
                            Type: CONTENT_TYPE_EVENT,
                        });

                        setLocalStorageData(LOCAL_STORAGE_KEY_AGENT_DATA, {
                            [data.Id]: {
                                ContactId: contactId, ...states.agents[contactId],
                                chatEnded: true
                            }
                        })
                        if (data.InitialContactId) {
                            const feedbackData = {[data.Id]: {ContactId: data.ContactId, feedbackResult: null}}
                            setLocalStorageData(LOCAL_STORAGE_KEY_FEEDBACK_DATA, feedbackData)
                        }
                    }
                }

                if (states.isTransferring
                    && !states.chatCanceled
                ) {
                    newMessages.push({
                        ContentType: CONTENT_TYPE_FEEDBACK,
                        ContactId: contactId,
                        Type: CONTENT_TYPE_EVENT,
                        transferFeedback: true  // unused !!??
                    });

                    if (data.InitialContactId) {
                        const feedbackData = {[data.Id]: {ContactId: data.ContactId, feedbackResult: null}}
                        setLocalStorageData(LOCAL_STORAGE_KEY_FEEDBACK_DATA, feedbackData)
                    }
                }
            }
        }

        return {
            newStates: newStates,
            newMessages: newMessages
        };
    }

    onMessage = (event) => {
        const {data} = event;

        if (this.state.chatEnded && data.ContentType === CONTENT_TYPE_CHAT_ENDED) {
            removeLocalStorageData(LOCAL_STORAGE_KEY_AGENT_DATA);
            removeLocalStorageData(LOCAL_STORAGE_KEY_FEEDBACK_DATA);
            return;
        }

        if ([MSG_LEX_BOT_ENTER_CHAT].indexOf(data.Content) !== -1) {
            try {
                this.state.session.sendMessage({
                    contentType: 'text/plain',
                    message: MSG_START_CHAT
                }).then(() => {
                    this.setState({
                        lexEnter: true,
                        showLocalMessages: false,
                        systemParticipantId: data.ParticipantId
                    });
                }).catch(() => {
                    this.endChat();
                });
            } catch (e) {
                this.endChat();
            }
        } else {
            if (data.ParticipantRole === ROLE_SYSTEM && data.Type === 'MESSAGE') {
                // Chatbot message
                this.setState({
                    isTyping: true,
                    incomingChatbotMessages: [...this.state.incomingChatbotMessages, data]
                });
            } else {
                // All other
                this.setState({
                    messages: [...this.state.messages, data]
                });
                if (data.ParticipantRole !== ROLE_CUSTOMER && data.Type === 'MESSAGE') {
                    if (data.ParticipantRole === ROLE_AGENT) {
                        try {
                            if (!this.state.windowFocused) {
                                this.messageSound.play(false, true);
                            }
                        } catch (e) {}
                    }
                    this.setState({
                        isTyping: false
                    });
                }
            }
        }

        const processedResult = this.processMessage(data, this.state);
        if (Object.keys(processedResult.newStates || {}).length) {
            this.setStates(processedResult.newStates);
        }
        if (processedResult.newMessages) {
            this.setState(prevState => {
                return {
                    messages: [
                        ...prevState.messages,
                        ...processedResult.newMessages
                    ]
                };
            });
        }

        // Billing queue additions
        if (data.ParticipantRole === ROLE_AGENT
            && data.ContentType === CONTENT_TYPE_JOINED
        ) {
            if (this.state.currentQueueName === 'Billing' || this.state.currentQueueName === 'Spanish Billing') {
                this.setState({
                    incomingChatbotMessages: [...this.state.incomingChatbotMessages, this.getAskDobMessage()]
                });
            }
        }
        if (data.ParticipantRole === ROLE_CUSTOMER
            && data.Type === 'MESSAGE'
        ) {
            if (this.nextAgentAutoMessageShow) {
                this.setState({
                    incomingChatbotMessages: [...this.state.incomingChatbotMessages, this.nextAgentAutoMessageShow]
                });
                this.nextAgentAutoMessageShow = null;
            }
        }
    };

    processIncomingChatbotMessage = (message, states, isRestored) => {
        let newStates = {};
        let newMessages = [];
        const jsonData = jsonParse(message.Content);
        if (jsonData) {
            if (jsonData.language && states.language !== jsonData.language) {
                i18n.setLocale(jsonData.language)
                if (states.language !== jsonData.language) {
                    newStates = Object.assign(newStates, {
                        language: jsonData.language,
                    });
                }
            }
            // value is string!
            if (typeof jsonData.askName === 'string' && jsonData.askName === 'true'
                || typeof jsonData.askName === 'boolean' && jsonData.askName
            ) {
                newStates = Object.assign(newStates, {
                    askName: true,
                    lexEnter: true,
                    showLocalMessages: false,
                    beforeConnectToAgent: true
                });
            }

            // value is string!
            if (typeof jsonData.askDOB === 'string' && jsonData.askDOB === 'true'
                || typeof jsonData.askDOB === 'boolean' && jsonData.askDOB
            ) {
                newStates = Object.assign(newStates, {
                    askName: true,
                    askDOB: true,
                    askDOBTitle: jsonData.askDOBTitle
                });
            }
            if (typeof jsonData.askPhone === 'string' && jsonData.askPhone === 'true'
                || typeof jsonData.askPhone === 'boolean' && jsonData.askPhone
            ) {
                newStates = Object.assign(newStates, {
                    askName: true,
                    askPhone: true,
                });
            }

            if (jsonData.cancelQueue === true
                || (jsonData.waitingMsg && jsonData.waitingMsg.cancelQueue === true)
            ) {
                Timers.waitingAgent = this.waitingAgentTimer();
                let buttonTitle = null;
                if (jsonData.cancelButtonTitle) {
                    buttonTitle = jsonData.cancelButtonTitle;
                }
                if (jsonData.waitingMsg) {
                    Timers.waitingQueueInfo = this.waitingQueueInfoTimer(jsonData.instanceId, jsonData.queueId, () => this.getCurrentContactId());
                    if (jsonData.waitingMsg.cancelButtonTitle) {
                        buttonTitle = jsonData.waitingMsg.cancelButtonTitle;
                    }
                    newStates = Object.assign(newStates, {
                        instanceId: jsonData.instanceId,
                        queueId: jsonData.queueId,
                    });
                }

                newStates = Object.assign(newStates, {
                    showCancelButton: true,
                    cancelButtonTitle: buttonTitle,
                    askName: false,
                    askDOB: false,
                });
            }

            if (jsonData.redirectUrl && !isRestored) {
                openUrl(jsonData.redirectUrl);
            }
            if (jsonData?.redirectUrl && !isRestored) {
                window.parent.postMessage({'name': 'linkClick', value: jsonData.redirectUrl}, '*')
            }


            //save link-buttons with "onlyRedirect"
            if (jsonData.type === 'interactive') {
                this.onlyRedirectButtons = [];
                if (jsonData.buttons && jsonData.buttons.length) {
                    try {
                        jsonData.buttons.forEach(button => {
                            if (button.onlyRedirect) {
                                this.onlyRedirectButtons.push(button);
                            }
                        });
                    } catch (e) {
                    }
                }
            }

            if (jsonData.type === 'EVENT') {
                if (jsonData.queueId) {
                    // get hello, transfer & unavailable agent messages for selected queue
                    this.getQueueMessages(jsonData.queueId);
                }
                // check transfer start
                if (jsonData.chatTransfer) {
                    newStates = Object.assign(newStates, {
                        isTransferring: true,
                        chatTransferred: true,
                        currentQueueName: null, // when start transferring - reset queue name
                        agents: {
                            ...states.agents,
                            [message.ContactId]: {...states.agents[message.ContactId], chatEnded: false}
                        }
                    });
                    newMessages.push({
                        Content: 'Chat transferred by Agent ' + getTimeAMPMFormat(new Date()),
                        ContentType: CONTENT_TYPE_TRANSFER,
                    });
                    setLocalStorageData(LOCAL_STORAGE_KEY_AGENT_DATA, {
                        [message.Id]: {
                            ContactId: message.ContactId, ...states.agents[message.ContactId],
                            chatEnded: false,
                        }
                    })
                }
                if (jsonData.queueName) {
                    newStates = Object.assign(newStates, {
                        currentQueueName: jsonData.queueName
                    });
                }
                if (jsonData.additionalData) {
                    let addAD = jsonData.additionalData;
                    if (typeof addAD === 'string') {
                        addAD = jsonParse(jsonData.additionalData);
                    }
                    newStates = Object.assign(newStates, {
                        additionalData: addAD
                    });
                }
            }
        }

        return {
            newStates: newStates,
            newMessages: newMessages,
            jsonData: jsonData
        };
    }

    initShowIncomingChatbotMessages = () => setInterval(() => {
        if (this.state.incomingChatbotMessages.length) {
            const msg = this.state.incomingChatbotMessages.shift();
            let states = Object.assign(this.state, {});

            let processedChatbotMsg = this.processIncomingChatbotMessage(msg, states, false);
            if (Object.keys(processedChatbotMsg.newStates || {}).length) {
                this.setStates(processedChatbotMsg.newStates);
            }

            const processedMsg = processedChatbotMsg.jsonData;

            // replace waiting information & mark message
            if (processedMsg && processedMsg.waitingMsg) {
                msg.chatbotIsWaitingInfo = true;
                msg.Content = JSON.stringify(processedMsg.waitingMsg);
                msg.queueName = processedMsg.queueName;
                msg.queueId = processedMsg.queueId;
            }

            this.setState({
                isTyping: this.state.incomingChatbotMessages.length > 0
            });

            // Add messages to main array
            if (processedMsg && Array.isArray(processedMsg.title)) {
                processedMsg.title.map((titleItem, i, arr) => {
                    let _msg = {...msg};
                    _msg.Content = titleItem;
                    if (arr.length === i + 1) {
                        let _content = {...processedMsg};
                        _content.title = titleItem;
                        _msg.Content = JSON.stringify(_content);
                    }
                    this.setState(prevState => {
                        return {messages: [...prevState.messages, _msg]};
                    });
                });
            } else {
                this.setState(prevState => {
                    return {messages: [...prevState.messages, msg]};
                });
            }

            if (processedChatbotMsg.newMessages) {
                this.setState(prevState => {
                    return {
                        messages: [
                            ...prevState.messages,
                            ...processedChatbotMsg.newMessages
                        ]
                    };
                });
            }
        }
    }, TIMEOUT_SHOW_CHATBOT_MESSAGE);

    getAskDobMessage = () => {
        return  {
            ParticipantRole: 'SYSTEM',
            Type: 'MESSAGE',
            ContentType: 'text/plain',
            Content: JSON.stringify({
                //title: "Hi my name is " + data.DisplayName + ", can I please have your Date of Birth or Responsible Person Number?",
                // type: "EVENT",
                title: '',
                hidden: true,
                askDOB: true,
                askDOBTitle: i18n.__("Enter Date of Birth (MM/DD/YYYY) or Responsible Person Number")
            })
        }
    }

    getDobThanksMessage = () => {
        return  {
            ParticipantRole: ROLE_AGENT,
            Type: 'MESSAGE',
            ContentType: 'text/plain',
            Content: i18n.__("Thanks! Give me one moment to review your request.")
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.doEndChat) {
            // end chat by timeout
            this.endChat();
        }
        if (prevState.messages
            && this.state.messages
            && prevState.messages.length !== this.state.messages.length
        ) {
            this.scrollToBottom();
        }
    }

    changeMessage = (e) => {
        const message = e.target.value;
        this.setState({
            message: message
        });
        if (message.length > 1024) {
            this.setState({
                showInputError: true
            });
        } else {
            this.setState({
                showInputError: false
            });
        }
        this.sendTypingEvent();
    };

    sendTypingEvent = () => {
        let needSend = false;
        let curDate = new Date();
        if (!this.state.lastTimeTyping) {
            this.state.lastTimeTyping = new Date();
            needSend = true;
        } else {
            needSend = (curDate.getTime() - this.state.lastTimeTyping.getTime() >= TIMEOUT_TYPING_EVENT);
        }
        if (needSend) {
            if (this.state.chatSession !== null) {
                this.state.lastTimeTyping = curDate;
                this.state.chatSession.sendEvent({
                    contentType: "application/vnd.amazonaws.connect.event.typing"
                });
            }
        }
    };

    updateTypingEventTimer = (isTyping = true) => {
        if (Timers.typingEvent) {
            clearTimeout(Timers.typingEvent);
        }
        this.setState({
            isTyping: isTyping
        });
        if (isTyping) {
            this.scrollToBottom();
            Timers.typingEvent = setTimeout(() => {
                this.setState({
                    isTyping: false
                });
                Timers.typingEvent = null;
            }, TIMEOUT_TYPING_EVENT);
        }
    }

    sendMessage = async (message = null, href = null) => {
        if (this.state.showInputError) {
            return false;
        }
        this.setState({
            message: "",
            lastTimeTyping: new Date(0),
        });
        if (this.state.messages.length) {
            try {
                const lastMessage = this.state.messages.slice(-1).pop();
                if (lastMessage.ParticipantRole === 'SYSTEM' && lastMessage.Content) {
                    const data = jsonParse(lastMessage.Content);
                    if (data.askName) {
                        if (data.queueType && data.queueType == 1) {
                            this.state.prescription = {};
                            this.setState({
                                prescription: {}
                            });
                        } else {
                            this.state.prescription = null;
                            this.setState({
                                prescription: null
                            });
                        }
                       await this.updateCustomerName(message)
                    }
                }
            } catch (e) {}
        }
        message = message.trim()
        if (checkEmptyInputText(message) || !this.state.lexEnter) {
            return false
        }

        this.userSentAnyMessage = true;

        if (this.state.askName && this.state.askDOB && this.state.currentQueueName === 'Billing') {
            this.nextAgentAutoMessageShow = this.getDobThanksMessage();
        }

        this.setState({
            askName: false,
            askDOB: false,
            askPhone: false,
        });

        try {
            if (!href) {
                try {
                    // stop show Chatbot messages
                    if (Timers.showChatbotMessage) {
                        clearInterval(Timers.showChatbotMessage);
                    }

                    if (this.lastMessageContext) {
                        this.lastMessageContext.setState({buttonClicked: true});
                    }

                    if (this.state.session) {
                        await this.state.session.sendMessage({
                            contentType: 'text/plain',
                            message: message
                        });
                        this.setState({
                            message: "",
                            messageSending: false
                        });
                    } else {
                        this.setState({
                            message: "",
                            localMessages: [...this.state.localMessages, message]
                        });
                    }
                    // this.scrollToBottom();
                } finally {
                    // restore show Chatbot messages
                    setTimeout(() => {
                        if (!this.state.showCancelButton
                            && !this.state.showRestartChat
                            && !this.state.showEndLiveChat
                        ) {
                            this.updateTypingEventTimer(true);
                        }
                        Timers.showChatbotMessage = this.initShowIncomingChatbotMessages();
                    }, 300);
                }

                // this.scrollToBottom();
                if (!this.state.isMobile && this.textarea) {
                    this.textarea.focus();
                }

                return true;
            }
        } catch (e) {
            console.log(e);
            return false;
        }
    }

    changeFeedbackMessage = (contactId, e) => {
        this.setState({
            feedbackValue:
                {
                    ...this.state.feedbackValue,
                    [contactId]: {...this.state.feedbackValue[contactId], 'feedbackMessage': e.target.value}
                }
        });
    }

    sendFeedback = (contactId, feedbackResult = false) => {
        this.setState({
            feedbackLoaderStatus: contactId
        });
        const result = feedbackResult !== false ? feedbackResult : this.state.feedbackValue[contactId] ? this.state.feedbackValue[contactId].feedbackResult : ""
        const helpReceived = this.state.feedbackValue[contactId] ? this.state.feedbackValue[contactId].helpReceived : ""
        const feedbackMessage = this.state.feedbackValue[contactId] ? this.state.feedbackValue[contactId].feedbackMessage : ""
        const chatEnded = this.state.agents[contactId] ? this.state.agents[contactId].chatEnded : false
        try {
            axios.put(process.env.REACT_APP_AMAZON_API_URL + '/feedback',
                {
                    contactId: contactId,
                    feedbackResult: result,
                    helpReceived: helpReceived,
                    feedbackMessage: feedbackMessage,
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    }
                }).then(() => {
                    this.setState({
                        showFeedback: feedbackResult !== false ? this.state.showFeedback : (!chatEnded && !this.state.showCancelFeedback),
                        showRestartChat: true,
                        feedbackLoaderStatus: null,
                        showCancelFeedback: false,
                        showCancelThanksMessage: true,
                        showThanksMessage: (result !== '' || helpReceived !== '' || feedbackMessage !== '')
                    });
                    if (feedbackResult !== false) {
                        this.setState({
                            feedbackValue: {
                                ...this.state.feedbackValue,
                                [contactId]: {...this.state.feedbackValue[contactId], feedbackResult: feedbackResult}
                            }
                        })
                    }
                    this.scrollToBottom();
                if (contactId) {
                    const feedbackDataLoaded = getLocalStorageData(LOCAL_STORAGE_KEY_FEEDBACK_DATA)
                    const foundKey = Object.keys(feedbackDataLoaded).find(key => feedbackDataLoaded[key].ContactId === contactId)

                    if (foundKey) {
                        const feedbackData = {
                            ...feedbackDataLoaded,
                            [foundKey]: {ContactId: contactId, feedbackResult: result}
                        }
                        setLocalStorageData(LOCAL_STORAGE_KEY_FEEDBACK_DATA, feedbackData)
                    } else {
                        console.warn('No matching ContactId found in cookie data')
                    }
                }
            });
        } catch (e) {
            console.log(e);
        }
    };
    skipFeedback = () => {
        this.setState({
            showFeedback: false,
            showRestartChat: true,
            feedbackLoaderStatus:null,
            skipFeedback:true
        })
    }

    cleanupChat = () => {
        this.setState({
            session: null,
            chatCanceled: false,
            showEndChat: false,
            showEndLiveChat: false,
            connectSuccess: false,
            attempts: 0,
            connectKeys: false,
            newSession: true,
            message: "",
            localMessages: [],
            incomingChatbotMessages: [],
            isTyping: false,
            showLocalMessages: false,
            lexEnter: false,
            showCancelButton: false,
            askName: false,
            askDOB: false,
            askPhone: false,
        });
    }

    deleteChatCookie = () => {
        window.parent.postMessage({'name': 'deleteCookie', value: true}, '*');
    }

    endChat = (deleteCookie = true) => {
        this.setState({
            doEndChat: false,
            isTransferring: false,
            isTransferred: false,
            chatEndedByCustomer: true,
        });
        return new Promise((resolve, reject) => {
            try {
                if (deleteCookie) {
                    this.deleteChatCookie();
                    // For standalone chat only
                    this.deleteCookies();
                }
                if (!this.chatEnded && this.state.session) {
                    this.state.session.disconnectParticipant()
                        .finally(() => {
                            this.onChatEnded();
                            resolve();
                        });
                } else {
                    resolve();
                }
            } catch (ex) {
                reject(ex.message);
            }
        });
    }

    cancelLiveChat = () => {
        this.setState({
            chatCanceled: true,
            showCancelFeedback:this.state.chatTransferred,
            chatTransferred:false,
            showCancelButton: false,
            showFeedback: true,
            needShowRestartChat: false,
            restartAfterFeedback: this.state.showFeedback
        });
        for (const s of document.getElementsByClassName("cancel-button")) {
            s.style.display = "none";
        }
        if (this.state.session) {
            this.state.session.sendMessage({
                contentType: 'text/plain',
                message: 'CANCEL_LIVE_CHAT'
            })
                .finally(()=> {
                    /* Delete Cookies for Standalone chat */
                    this.endChat(true)
                        .finally(() => {
                            /* Disable restart for Standalone chat */
                            //this.initiateChat();
                        });
                });
        }
    };

    endLiveChat = (needReload = false) => {
        this.setState({
            showEndLiveChat: false
        });
        return new Promise((resolve, reject) => {
            this.endChat(false)
                .then(() => {
                    if (needReload) {
                        setTimeout(() => {
                            if (!this.state.showFeedback) {
                                this.initiateChat()
                            }
                        }, 100);
                    } else {
                        this.setState({restartAfterFeedback:true})
                    }
                    resolve();
                })
                .catch((err) => {
                    reject('Can\'t End Chat: ' + err);
                });
        });
    };

    restartChat = () => {
        this.setState({
            showRestartChat: false,
        });
        this.endLiveChat(false)
            .catch(err => {
                console.log(err)
            })
            .finally(() => {
                window.location.reload();
            });
    };

    onChatEnded = () => {
        this.cleanupChat();
        this.state.chatEnded = true; // change immediately
        /* // Disabled for Standalone chat
        this.setState({
            showRestartChat: this.state.needShowRestartChat,
        });
        this.lastMessageContext.setState({
            buttonClicked: true
        });
        */
        if (Timers.endLiveChat !== null) {
            clearTimeout(Timers.endLiveChat);
        }
        if (!Timers.clearChat) {
            this.chatEndTime = Date.now();
            Timers.clearChat = this.clearChatTimer(TIMEOUT_CLEAR_CHAT);
        }
        setTimeout(() => {
            this.scrollToBottom();
        }, 100);
    }

    onButtonClick = async (message, href, additionalInfo = null) => {
        if (href) {
            if (additionalInfo
                && additionalInfo.hasOwnProperty('button')
                && additionalInfo.button.hasOwnProperty('intent')
            ) {
                await this.sendMessage(MSG_GET_INTENT_DESCRIPTION + ' ' + additionalInfo.button.intent, null);
            }
            window.parent.postMessage({'name': 'linkClick', value: href}, '*')
            // For standalone chat only
            window.location.href = href;
        } else {
            await this.sendMessage(message, href, true)
        }
    }

    scrollToBottom = () => {
        if (this.messagesEnd) {
            this.messagesEnd.scrollIntoView({behavior: "smooth"})
        }
    }

    // closeChat = () => {
    //     window.parent.postMessage({name: 'closeChat', value: true}, '*')
    // }

    separateMessage = (data) => {
        if(data.Content === null || data.Type === CONTENT_TYPE_EVENT) {
            return [data]
        }
        let messages = data.Content.split('[!]')
        let separatedMessages = []
        if (messages.length) {
            messages.forEach((message => {
                let newData = Object.assign({}, data);
                newData.Content = message
                separatedMessages.push(newData)
            }))
            return separatedMessages
        } else {
            return [data]
        }
    }

    setLastMessageContext = (context) => {
        this.lastMessageContext = context;
    }

    checkIsLastMessage = (messages, key) => {
        let isLast = true;
        for (let i = key; i < messages.length; i++) {
            let nextMessage = messages[i + 1];
            if (!nextMessage) {
                break;
            } else {
                if (nextMessage.Type === CONTENT_TYPE_EVENT) {
                    continue;
                }

                if (!this.state.agentConnected
                    && nextMessage.Type === 'MESSAGE'
                    && nextMessage.ParticipantRole === 'CUSTOMER'
                    && nextMessage.Content === MSG_WAITING_AGENT
                ) {
                    isLast = false;
                    break;
                }

                if (nextMessage.ParticipantRole === 'SYSTEM') {
                    let data = jsonParse(nextMessage.Content);
                    if (data && data.type !== CONTENT_TYPE_EVENT) {
                        isLast = false;
                        break;
                    }
                }
                if (this.state.agentConnected
                    && nextMessage.Type === 'MESSAGE'
                ) {
                    isLast = false;
                    break;
                }
            }
        }
        return isLast;
    }

    renderMessages() {
        const {messages} = this.state;
        let agentParticipantId = null;
        this.state.filteredMessages = messages.filter(message => {
            const skipJoinedMessage = (
                message.ParticipantRole === ROLE_AGENT
                && message.Type === CONTENT_TYPE_EVENT
                && message.ContentType === CONTENT_TYPE_JOINED
                && message.ParticipantId === agentParticipantId
            );
            // save agent joined
            if (message.ParticipantRole === ROLE_AGENT
                && message.Type === CONTENT_TYPE_EVENT
                && message.ContentType === CONTENT_TYPE_JOINED
                && message.ParticipantId !== agentParticipantId
            ) {
                agentParticipantId = message.ParticipantId;
            }

            return !(message.Content && (
                    message.Content === MSG_START_CHAT
                    || message.Content.indexOf(MSG_GET_INTENT_DESCRIPTION) !== -1
                )
                || skipJoinedMessage
            );
        });
        let firstTransferKey = false;
        let usedQueue = {};
        return this.state.filteredMessages.map((message, key) => {
            if (message.queueId && message.queueName) {
                usedQueue = {
                    name: message.queueName,
                    id: message.queueId
                };
            }
            if (message.DisplayName === 'BOT' || message.DisplayName === 'SYSTEM_MESSAGE') {
                try {
                    const messageJson = jsonParse(message.Content);
                    if (messageJson && messageJson.type === CONTENT_TYPE_EVENT) {
                        if (messageJson.queueName) {
                            usedQueue = {
                                name: messageJson.queueName,
                                id: messageJson.queueId
                            };
                        }
                    }
                } catch (e) {}
            }

            message.usedQueue = usedQueue; //ToDo: Object.assign({}, usedQueue);

            if(message.ContentType === CONTENT_TYPE_TRANSFER_SUCCEEDED){
                firstTransferKey = key
            }
            const showTransferMessage = firstTransferKey ? key > firstTransferKey : false
            return this.renderMessage(message, key, showTransferMessage);
        });
    }

    renderMessage = (message, key, showTransferMessage = false) => {
        const {username, avatarUrl, showCancelButton, cancelButtonTitle, showRestartChat, newSession, filteredMessages, feedbackValue, showFeedback} = this.state;
        let isHidden = false;
        let {prescription,language} = this.state;
        if (message.ParticipantRole === ROLE_SYSTEM && !message.ParticipantId) {
            message.ParticipantId = this.state.systemParticipantId;
        }
        if (message.DisplayName === 'BOT' || message.DisplayName === 'SYSTEM_MESSAGE') {
            try {
                let messageJson = jsonParse(message.Content);
                if (messageJson && messageJson.type === CONTENT_TYPE_EVENT) {
                    if (messageJson.language && messageJson.language !== language){
                        i18n.setLocale(messageJson.language)
                    }
                    // Prescription refill data
                    if (messageJson.customerDOB && prescription && !prescription.customerDOB) {
                        prescription = messageJson;
                        this.setState({
                            prescription: messageJson
                        });
                        if (!Array.isArray(prescription.additionalData)) {
                            try {
                                prescription.additionalData = jsonParse(prescription.additionalData);
                            } catch (e) {
                                prescription.additionalData = [];
                            }
                        }
                    }
                }
            } catch (e) {}
        }

        const isLast = this.checkIsLastMessage(filteredMessages, key);
        const nextMessage = filteredMessages[key + 1];
        if (nextMessage && nextMessage.Type !== CONTENT_TYPE_EVENT) {
            try {
                let data= jsonParse(nextMessage.Content);
                isHidden = data.hidden === true;
            } catch (e) {}
        }
        const isTransferringGreeting =  filteredMessages.filter((message)=>{
            return message.ContentType ===CONTENT_TYPE_TRANSFER
        }).length >= 1
        return <Template init={this.setLastMessageContext.bind(this)}
                         key={'tpl_' + key}
                         dataKey={'tpl_' + key}
                         baseMessage={message}
                         type={message.ContentType}
                         role={message.ParticipantRole}
                         message={message.Content}
                         messageDate={message.AbsoluteTime}
                         displayName={message.DisplayName}
                         /*acceptedAgreement={this.state.acceptedAgreement}*/
                         username={username}
                         avatar={avatarUrl}
                         showCancelButton={showCancelButton}
                         cancelButtonTitle={cancelButtonTitle}
                         showRestartChat={showRestartChat}
                         onButtonClick={this.onButtonClick}
                         newSession={newSession}
                         cancelLiveChat={this.cancelLiveChat}
                         restartChat={this.restartChat}
                         scrollToBottom={this.scrollToBottom}
                         prescription={prescription}
                         last={isLast}
                         isLastInChain={
                             (
                                 (
                                     nextMessage !== undefined
                                     && ((nextMessage.ParticipantId !== message.ParticipantId
                                         && !([ROLE_SYSTEM, ROLE_AGENT].indexOf(nextMessage.ParticipantRole) !== -1
                                         && [ROLE_SYSTEM, ROLE_AGENT].indexOf(message.ParticipantRole) !== -1)
                                         && nextMessage.ContentType !== CONTENT_TYPE_LEFT
                                         && nextMessage.Type !== CONTENT_TYPE_EVENT
                                     ))
                                 )
                                 || nextMessage === undefined
                                 || nextMessage.hide === true
                                 || nextMessage.ContentType === CONTENT_TYPE_LEFT && nextMessage.ParticipantRole !== filteredMessages[key].ParticipantRole && nextMessage.ParticipantRole === 'AGENT'
                                 || nextMessage.ContentType === CONTENT_TYPE_LEFT && nextMessage.ParticipantRole === filteredMessages[key].ParticipantRole && nextMessage.ParticipantRole === 'CUSTOMER'
                                 || isHidden
                             )
                         }
                         isSafari={this.state.isSafari}
                         sendFeedback={this.sendFeedback}
                         feedbackValue={feedbackValue}
                         showFeedback={showFeedback}
                         sendMessage={this.sendMessage}
                         askName={this.state.askName}
                         askDOB={this.state.askDOB}
                         askPhone={this.state.askPhone}
                         askDOBTitle={this.state.askDOBTitle}
                         onUpdateFeedback={this.onUpdateFeedback}
                         agentName={this.state.agentName}
                         customerName={this.state.customerName}
                         feedbackLoaderStatus={this.state.feedbackLoaderStatus}
                         getCurrentContactId={this.getCurrentContactId}
                         chatEnded={this.state.chatEnded}
                         chatEndedByCustomer={this.state.chatEndedByCustomer}
                         showTransferMessage={showTransferMessage}
                         showTimeoutMessage={this.state.showTimeoutMessage}
                         showThanksMessage={this.showThanksMessage}
                         contactId={message.ContactId}
                         changeFeedbackMessage={this.changeFeedbackMessage}
                         skipFeedback={this.skipFeedback}
                         language={this.state.language}
                         transferFeedback={message.transferFeedback ? message.transferFeedback : false}
                         showCancelFeedback={this.state.showCancelFeedback}
                         agents={this.state.agents}
                         startQueueName={this.props.startQueueName}
                         predefinedMessages={this.state.predefinedMessages}
                         queueMessages={this.state.queueMessages}
                         queueMessagesLoading={this.state.queueMessagesLoading}
        />
    }

    makeId = (length = 20, characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789') => {
        var result = '';
        var charactersLength = characters.length;
        for (var i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }


    render() {
        const {
            backgroundColor,
            fontName,
            cssUrl,
            headerColor,
            messages,
            showLocalMessages,
            localMessages,
            showEndChat,
            showEndLiveChat,
            isTyping,
            // acceptedAgreement,
            message,
            logoUrl,
            showFeedback,
            feedbackValue,
            skipFeedback
        } = this.state;
        let contactId = showFeedback?this.getCurrentContactId():''
        return (
            <Container className="chat__wrap"
                       id="chat__wrap"
                       style={
                           {backgroundColor: backgroundColor ? backgroundColor : "rgba(255, 255, 255, 1)"}
                       }>
                {
                    <style>
                        {

                            "@import url('https://fonts.googleapis.com/css?family=" + fontName + "');" +
                            "* {\n" +
                            "    font-family: '" + fontName + "', sans-serif;\n" +
                            "    font-weight: normal;\n" +
                            "    font-size: 16px\n" +
                            "}"
                        }
                    </style>
                }
                {
                    cssUrl && <link rel="stylesheet" id="style-direction" href={cssUrl}/>
                }

                <header className="header__chat row"
                     style={{backgroundColor: headerColor ? headerColor : "rgba(255, 255, 255, 1)"}}>
                    <Row className="header__inner">
                    {
                        <img src={logoUrl ? logoUrl : HEADER_SVG} className="logo"/>
                    }
                    {
                        showEndLiveChat ? <a className="endLiveChatButton" onClick={() => this.endLiveChat(false)}>End Live Chat</a> : <></>
                    }
                    </Row>
                </header>
                <main className="justify-content-md-center messages row">
                    {
                        this.renderMessages()
                    }
                    {
                        isTyping && (!this.state.askName || !this.state.askDOB || !this.state.askPhone) /*&& acceptedAgreement*/ ?
                            this.renderMessage({ContentType: CONTENT_TYPE_TYPING}, -1)
                            :
                            <></>
                    }
                    {
                        this.state.chatEnded && !this.state.showFeedback  && feedbackValue[this.getCurrentContactId()]
                        && this.state.showThanksMessage && !skipFeedback
                        && <div className="message-box "><div className="message-box feedback thanks">
                            Thank you for taking time to give us feedback on your chat experience.
                        </div></div>
                    }
                    {
                        this.state.chatEnded && this.state.showTimeoutMessage
                        && <div className="message-box "> <div className="feedback thanks">
                            Chat session ended due to inactivity. Please refresh your screen.
                        </div></div>
                    }
                    {
                        this.state.chatEnded && this.state.showCleanedChatMessage
                        && <div className="message-box "> <div className="feedback thanks">
                            Chat transcript hidden for your privacy and security.
                        </div></div>
                    }
                    <div style={{float: "left", clear: "both"}}
                         ref={(el) => {
                             this.messagesEnd = el
                         }}>
                    </div>

                </main>
                <footer className={"input__container " + (this.state.showFeedback && this.state.chatEnded?"hidden":"") + (this.state.showInputError ? "error" : "")}>
                    {/*<a className="exitChat" title="End Chat" onClick={() => this.endChat()}>*/}
                    {/*    <FontAwesomeIcon width={32} icon={faSignOutAlt}/>*/}
                    {/*</a>*/}
                    {this.state.showInputError && <label className={"error"}>Message must be less then 1024 characters</label>}
                    <div className="input__inner">
                    <input
                        autoFocus={false}
                        ref={c => this.textarea = c}
                        className="chat__input"
                        placeholder={this.state.showFeedback && this.state.chatEnded ? "Additional feedback or comments (optional)" : "Type your question here..."}
                        value={this.state.showFeedback && this.state.chatEnded ? this.state.feedbackValue[contactId] ? this.state.feedbackValue[contactId].feedbackMessage : "" : message}
                        disabled={(!this.state.lexEnter || this.state.askName) && !this.state.showFeedback}
                        onChange={(e) => {
                            this.changeMessage(e)
                        }}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.keyCode === 13) {
                                e.preventDefault();
                                if (this.state.askName) {
                                    return false;
                                }
                                this.sendMessage(message, null, true);
                            }
                        }}
                    />

                    <a className="sendMessage"
                       onKeyDown={keydownHandler}
                       tabIndex={0}
                       onClick={() => {
                           if (this.state.askName) {
                               return false;
                           }
                           this.sendMessage(message, null, true);
                       }}>
                        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="32px" height="32px" viewBox="0 0 116 95" version="1.1">
                            <title>Path</title>
                            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinejoin="round">
                                <polygon id="Path" stroke="#02818A" strokeWidth="4" fill="#02818A" points="2 2 114 47.5 2 93 2 55.7738953 58 47.5 2 38.761322"/>
                            </g>
                        </svg>
                    </a>
                    </div>
                </footer>

            </Container>
        )
    }
}
